export default __webpack_public_path__ + "static/media/logo-vidal.724fc604.svg";